module.exports = __webpack_public_path__ + "static/panelwithprogress-ab3722139783e10446ba2e613f8856c2.png";